<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="sp"> </p>
<p class="epi_epiv_only"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><i>If something exists somewhere, it will exist everywhere.</i></span></p>
<p class="epi_episrc"><span class="small">—CZESŁAW MIŁOSZ</span></p>
<p class="epi_epiv_only"><i>Love came … after the kill.</i></p>
<p class="epi_episrc"><span class="small">—ANNE SEXTON</span></p>
<p class="epi_epiv_first"><i>I wonder if there is</i></p>
<p class="epi_epiv_middle"><i>any operation</i></p>
<p class="epi_epiv_last"><i>that removes memories.</i></p>
<p class="epi_episrc"><span class="small">—SHINOE SHŌDA</span></p>
<p class="epi_epiv_middle"><i>… and if my body is still the soft part of the mountain</i></p>
<p class="epi_epiv_middle"><i>I’ll know</i></p>
<p class="epi_epiv_middle"><i>I am not yet the mountain.</i></p>
<p class="epi_episrc"><span class="small">—JOSÉ WATANABE</span></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?49fb85d4